import type { Row } from '@tanstack/react-table';

export type NumberFilterValue =
  | { op: 'eq' | 'gt' | 'lt'; value?: string }
  | { op: 'range'; min?: string; max?: string };

export const textIncludesFn = <T>(row: Row<T>, id: string, value: string): boolean => {
  if (!value) return true;
  return String(row.getValue(id) ?? '')
    .toLowerCase()
    .includes(value.toLowerCase());
};

export const numberFn = <T>(row: Row<T>, id: string, value: NumberFilterValue): boolean => {
  const cell = Number(row.getValue(id)) || 0;
  if (value.op === 'range') {
    if (value.min) {
      const min = Number(value.min);
      if (!Number.isNaN(min) && cell < min) return false;
    }
    if (value.max) {
      const max = Number(value.max);
      if (!Number.isNaN(max) && cell > max) return false;
    }
    return true;
  }
  if (!value.value) return true;
  const target = Number(value.value);
  if (Number.isNaN(target)) return true;
  if (value.op === 'eq') return cell === target;
  if (value.op === 'gt') return cell > target;
  return cell < target;
};

export const selectEqualsFn = <T>(row: Row<T>, id: string, value: string): boolean => {
  if (!value) return true;
  return String(row.getValue(id) ?? '') === value;
};
